function responsive() {
    return(
        <div>
        </div>
    )

}
export default responsive;